import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useBasicStoresMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation('toggleBasicStoresStatus', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['basicStores'] });
      toast.success(res.message);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });

  const { mutateAsync: deletestore } = useMutation('deleteBasicStoreInfo', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['basicStores'] });
      toast.success(res.message);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutate: mutateAsync, mutateAsync: deletestore };
};

export default useBasicStoresMutation;
